import type { BatchCosignBody, BatchCosignResponse } from "@/core/types";
import { cosignatureRequestsTyped } from "@/api/(requests)/cosignatureTyped";

export async function batchCosignAction(data: BatchCosignBody): Promise<BatchCosignResponse> {
  return cosignatureRequestsTyped.batch_cosign({ data });
}
